module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-ca5c544d6ea426e32b4d5bde7c46825f.svg";